import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@Services';

export const sessionGuard: CanActivateFn = () => {
  const _authService = inject(AuthService);

  const accessToken = sessionStorage.getItem('access_token');
  const refreshToken = sessionStorage.getItem('refresh_token');

  if (accessToken && refreshToken) {
    _authService.setSession(accessToken, refreshToken);
  }
  return true;
};
